// extracted by mini-css-extract-plugin
module.exports = {"row":"Earning_row__3IGH2","col":"Earning_col__i-Uti","card":"Earning_card__kBFBy"};